import { withProps } from 'recompose';

import { Image } from 'components/core/Image';

import storage25Image from 'assets/images/size-guide/unit--25sqft.png';
import storage50Image from 'assets/images/size-guide/unit--50sqft.png';
import storage75Image from 'assets/images/size-guide/unit--75sqft.png';
import storage100Image from 'assets/images/size-guide/unit--100sqft.png';
import storage150Image from 'assets/images/size-guide/unit--150sqft.png';
import storage200Image from 'assets/images/size-guide/unit--200sqft.png';
import storage300Image from 'assets/images/size-guide/unit--300sqft.png';
import outdoorImage from 'assets/images/size-guide/unit--parking-outdoor.png';
import parkingImage from 'assets/images/size-guide/unit--parking.png';
import lockerImage from 'assets/images/size-guide/unit--locker.png';
import workspaceImage from 'assets/images/size-guide/unit--workspace.png';
import wineImage from 'assets/images/size-guide/unit--wine.png';

const icons = {
	25: storage25Image,
	50: storage50Image,
	75: storage75Image,
	100: storage100Image,
	150: storage150Image,
	200: storage200Image,
	300: storage300Image,
};

function getStorageClass(squareFootage) {
	const storageClasses = Object.keys(icons);

	for (let i = 0; i < storageClasses.length; i += 1) {
		if (squareFootage <= storageClasses[i]) {
			return storageClasses[i];
		}
	}
	return storageClasses[storageClasses.length - 1];
}

export const enhance = withProps(({ amenities, squareFootage, type, className }) => {
	let src;

	switch (type) {
		case 'locker':
			src = lockerImage;
			break;
		case 'parking_space':
		case 'outdoor':
			src = outdoorImage;
			if (amenities && amenities.covered) {
				src = parkingImage;
			}
			break;
		case 'workspace':
			src = workspaceImage;
			break;
		case 'wine_storage':
			src = wineImage;
			break;
		default:
			src = icons[getStorageClass(squareFootage)];
			break;
	}
	return {
		className: className ? `unit-icon ${className}` : 'unit-icon',
		alt: 'unit icon',
		lazyLoad: true,
		src,
	};
});

export default enhance(Image);
